import React from 'react';
import randomColor from 'randomcolor';
import './style.less';
import clsx from 'clsx';

const getInitials = (name: string) => {
  if (name === '' || name.trim() === '') {
    return null;
  }
  const eachName = name.split(/\s+/);
  if (eachName.length > 1) {
    // max two chars
    return (eachName[0][0] + eachName[1][0]).toUpperCase();
  } else {
    return eachName[0][0].toUpperCase();
  }
};

interface EmptyAvatarProps extends Omit<React.HTMLProps<HTMLDivElement>, 'id'> {
  id: number | string;
  name: string;
  size?: number;
  luminosity?: 'bright' | 'light' | 'dark' | 'random';
}

const EmptyAvatar: React.FC<EmptyAvatarProps> = ({
  id,
  name,
  size,
  luminosity,
  className,
  ...rest
}) => {
  if (!name) {
    name = '?';
  }
  if (!luminosity) {
    luminosity = 'dark';
  }

  const styleSize = size || 30;

  return (
    <div
      {...rest}
      className={clsx('EmptyAvatar', className)}
      style={{
        lineHeight: styleSize,
        background: randomColor({ seed: id, luminosity: luminosity }),
      }}
    >
      <p
        className="EmptyAvatar__agent-name"
        style={{ fontSize: `${styleSize / 3 || 10}px` }}
      >
        {getInitials(name)}
      </p>
    </div>
  );
};

export default EmptyAvatar;
